<template>
    <div>
        <DataLoader :is_on="creating_report" />
        <div id="table" class="report-table predmeti-report">
            <div class="rocisnik-top">
                <div class="rokovnik-title">{{$store.state.predmeti_report_data.naslov}}</div>
                <div class="print-wrapper" @click="print()">
                    <span>Preuzmi izvještaj</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="36" viewBox="0 0 30 36" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M12.5574 0C11.0601 0 9.81104 1.21625 9.68029 2.8016C9.40692 6.11624 9.33774 9.44566 9.47296 12.7686C9.30973 12.7802 9.14654 12.7923 8.98336 12.8049L6.10045 13.0283C4.25777 13.1711 3.2277 15.3548 4.22251 17.0096C6.34414 20.5386 9.07791 23.6066 12.2781 26.05L13.4331 26.9318C14.3695 27.6468 15.6308 27.6468 16.5672 26.9318L17.7222 26.05C20.9224 23.6066 23.6562 20.5386 25.7778 17.0096C26.7726 15.3548 25.7425 13.1711 23.8999 13.0283L21.017 12.8049C20.8538 12.7923 20.6906 12.7802 20.5273 12.7686C20.6626 9.44565 20.5934 6.11623 20.32 2.80158C20.1893 1.21624 18.9402 0 17.4429 0H12.5574ZM12.4482 14.1217C12.2281 10.4452 12.2692 6.75601 12.5712 3.08571H17.4291C17.7311 6.75601 17.7722 10.4452 17.5521 14.1217C17.5274 14.5339 17.6593 14.9394 17.9181 15.2474C18.177 15.5555 18.5412 15.7404 18.9294 15.7607C19.5552 15.7934 20.1807 15.834 20.8059 15.8825L22.8996 16.0447C21.0424 18.9521 18.717 21.4911 16.0284 23.5438L15.0002 24.3289L13.9719 23.5438C11.2833 21.4911 8.95788 18.9521 7.10071 16.0447L9.19443 15.8825C9.81957 15.834 10.4451 15.7934 11.0709 15.7607C11.4591 15.7404 11.8233 15.5555 12.0822 15.2474C12.341 14.9394 12.4729 14.5339 12.4482 14.1217Z"
                            fill="#606076" />
                        <path
                            d="M2.90323 28.2857C2.90323 27.4336 2.25332 26.7429 1.45161 26.7429C0.649909 26.7429 0 27.4336 0 28.2857V32.4C0 34.3882 1.51646 36 3.3871 36H26.6129C28.4835 36 30 34.3882 30 32.4V28.2857C30 27.4336 29.3501 26.7429 28.5484 26.7429C27.7467 26.7429 27.0968 27.4336 27.0968 28.2857V32.4C27.0968 32.684 26.8801 32.9143 26.6129 32.9143H3.3871C3.11986 32.9143 2.90323 32.684 2.90323 32.4V28.2857Z"
                            fill="#606076" />
                    </svg>
                </div>
                <div class="remove-this" v-if="nositelj != null" @click="filterNositelj()">
                    <div v-if="!filter_active" class="archived-destroyed-element unisti"><b>Filtriraj predmete gdje je odabrani odvjetnik nositelj</b></div>
                    <div v-else class="archived-destroyed-element sve"><b>Prikaži sve predmete odabranog odvjetnika</b></div>
                </div>
            </div>
            <a @click="goBack()" class="entry-exit"><img src="@/assets/img/entry_form_close.svg" /></a>
            <div id="wrapp-roc-pdf">
                <div class="report-row report-main-header">
                    <div class="column column1">
                        Br.
                    </div>
                    <div class="column column2">
                        Stranka
                    </div>
                    <div class="column column3">
                        Protustranka
                    </div>
                    <div class="column column4">
                        Poslovni broj
                    </div>
                    <div class="column column5">
                        Nadležnost
                    </div>
                    <div class="column column6">
                        Članovi tima
                    </div>
                </div>
                <div class="report-section">
                    <!-- <div class="report-row report-date-row"></div> -->
                    <div v-for="(predmet,key) in predmeti" :key="key" class="report-row report-rociste">
                        <div class="column column1">
                            {{predmet.broj_predmeta}}
                        </div>
                        <div class="column column2 multiple-values">
                            <div v-for="(fiz_s,key) in predmet.connect_fiz_stranka" :key="key">{{fiz_s.fizicka_osoba.ime}} {{fiz_s.fizicka_osoba.prezime}}</div>
                            <div v-for="(prav_s,key) in predmet.prav_connect_stranka" :key="'100'+key">{{prav_s.pravna_osoba.ime}}</div>
                        </div>
                        <div class="column column3 multiple-values">
                            <div v-for="(fiz_pr,key) in predmet.connect_fiz_protustranka" :key="'200'+key">{{fiz_pr.fizicka_osoba.ime}} {{fiz_pr.fizicka_osoba.prezime}}</div>
                            <div v-for="(prav_pr,key) in predmet.prav_connect_protustranka" :key="'300'+key">{{prav_pr.pravna_osoba.ime}}</div>
                        </div>
                        <div class="column column4 multiple-values">
                            <div v-for="(sp,key) in predmet.spis" :key="'500'+key">
                                {{sp.posl_br != undefined && sp.posl_br != null ? sp.posl_br : ''}}
                            </div>
                        </div>
                        <div class="column column5 multiple-values">
                            <div v-for="(inst,key) in predmet.spis" :key="'400'+key" >
                                {{inst.institucija != undefined && inst.institucija != null ? inst.institucija.naziv : ''}}
                            </div>
                        </div>
                        <div class="column column6 multiple-values">
                            <div v-for="(odv,key) in predmet.predmet_odvjetnik_connector" :key="key"><span :style="odv.status_odvjetnik_predmet.id_status == 2 ? 'font-weight:600' : ''">{{odv.odvjetnik.ime}} {{odv.odvjetnik.prezime}}</span></div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import moment from "moment";
import $ from 'jquery';
import gsap from 'gsap';
import ms_calendar from "@/apiCallers/calendarSharepoint";
import DataLoader from '@/components/generalComponents/DataLoader';

export default {
    components:{
        DataLoader,
    },
    data() {
        return {
            predmeti: [],
            razdoblje: '',
            creating_report: false,
            nositelj:null,
            predmeti_backup: [],
            filter_active: false,
        }
    },
    methods: {
        async print() {
            this.creating_report = true;
            let temp_str = $("html").clone()
            $(temp_str).find(".print-wrapper,.entry-exit,.remove-this").remove()
            let html_to_print = $(temp_str)[0].outerHTML
            await ms_calendar.printCalendar(html_to_print).then(async(resp) => {
                var newBlob = new Blob([resp.data], {
                  type: "application/pdf",
                });
                var data = window.URL.createObjectURL(newBlob);

                var link = document.createElement("a");
                link.href = data;
                link.download =this.nositelj != null ? `popis-predmeta-${this.$store.state.predmeti_report_data.odvjetnik_name}-` + moment().format("l") + ".pdf" : "popis-predmeta-" + moment().format("l") + ".pdf" ;
                link.click();
                setTimeout(function () {
                  // For Firefox it is necessary to delay revoking the ObjectURL
                  window.URL.revokeObjectURL(data);
                }, 100);
                this.creating_report = false;
            }).catch((_err)=>{
                this.creating_report = false;
            })
            //html_to_print sadrzi html izvjestaj spreman za print
            //poslati html_to_print na back endpoint
        },
        getDate(date) {
            return moment(date).format("DD.MM.yyyy.");
        },
        getToday() {
            return moment().format("DD.MM.yyyy.");
        },
        getDayName(date) {
            return moment(date).format("dddd");
        },
        getSatiEvent(fullDateTime) {
            return moment(fullDateTime).format("LT");
        },
        goBack() {
            this.$router.go(-1);
        },
        filterNositelj(){
            if (!this.filter_active) {
                this.predmeti = this.predmeti_backup.filter((pr)=>pr.predmet_odvjetnik_connector.find(od=>od.odvjetnik.uid == parseInt(this.nositelj) && od.status_odvjetnik_predmet.id_status == 2));
            }
            else{
                this.predmeti = [...this.predmeti_backup]
            }
            this.filter_active = !this.filter_active;
        },
    },
    created(){
        this.nositelj = this.$store.state.predmeti_report_data.odvjetnik_nositelj;
        
    },
    mounted() {
        document.body.classList.add("new-entry");
        if(this.$store.state.predmeti_report_data.naslov == ''){
            this.$router.go(-1);
        }
        this.predmeti = this.$store.state.predmeti_report_data.all_predmeti;
        this.predmeti_backup = [...this.predmeti];
        $(".entry-exit").hover(
            function () {
                gsap.to($(this).find("img"), 0.3, {
                    rotation: 180,
                    transformOrigin: "center",
                });
            },
            function () {
                gsap.to($(this).find("img"), 0.5, {
                    rotation: -180,
                    transformOrigin: "center",
                });
            }
        );
    },
    destroyed() {
        this.$store.state.predmeti_report_data={
			all_predmeti: [],
			naslov: '',
			odvjetnik_nositelj:null,
			odvjetnik_name:''
		}
        document.body.classList.remove("new-entry");
        $(".entry-exit").off();
    },
}
</script>